import classNames from 'classnames';
import { values } from 'lodash';
import React from 'react';
import Link from './Link';

export default function Button({
  clickHandler,
  label = '',
  ariaLabel = '',
  w = 'min-w-[150px]',
  h = 'min-h-[42px]',
  px = 'px-8',
  py = 'py-2',
  bg,
  hover,
  text,
  font = 'font-bold not-italic',
  border,
  shadow = '',
  url = '',
  target = '_self',
  leading = '',
  rounded = '',
  external = false,
  disabled = 'disabled:opacity-10 disabled:pointer-events-none',
  isDisabled = false,
  variant,
  reverse,
  transition = 'transition duration-300 ease-in-out',
  tagName,
}) {
  const callback = (cl) => cl;

  const variants = {
    primaryRed: {
      bg: 'bg-red',
      hover: `hover:shadow-sm hover:bg-white hover:text-black
        hover:border-red`,
      text: 'text-xs text-white uppercase rounded-sm font-roboto-bold',
      border: 'border border-red',
    },
    secondaryRed: {
      bg: 'bg-white',
      hover: `hover:shadow-sm hover:bg-red hover:text-white
      hover:border-white`,
      text: 'text-xs text-red uppercase rounded-sm font-roboto-bold',
      border: 'border border-red',
    },
    primaryGrey: {
      bg: 'bg-bg-4',
      hover: `hover:shadow-sm-dark hover:bg-black hover:text-white
        hover:border-black`,
      text: 'text-xs text-black uppercase rounded-sm font-roboto-bold',
      border: 'border border-bg-4',
    },
    primaryWhite: {
      bg: 'bg-bg-5',
      hover: `hover:shadow-sm-dark hover:bg-black hover:text-black-100
        hover:border-black hover:text-white`,
      text: 'text-xs text-black uppercase rounded-sm font-roboto-bold',
      border: 'border border-bg-5',
    },
  };

  const getVariant = () => {
    if (variant) {
      const objValues = values(variants[variant]);
      const str = objValues.join(' ');
      return str;
    }
    return '';
  };

  const classname = classNames({
    flex: true,
    'cursor-pointer': true,
    'items-center': true,
    'justify-center': true,
    'flex-row-reverse': reverse,
    [`${callback(w)}`]: w,
    [`${callback(h)}`]: h,
    [`${callback(px)}`]: px,
    [`${callback(py)}`]: py,
    [`${callback(bg)}`]: bg,
    [`${callback(hover)}`]: hover,
    [`${callback(text)}`]: text,
    [`${callback(font)}`]: font,
    [`${callback(leading)}`]: leading,
    [`${callback(shadow)}`]: shadow,
    [`${callback(rounded)}`]: rounded,
    [`${callback(disabled)}`]: disabled,
    [`${callback(transition)}`]: transition,
    [`${callback(border)}`]: border,
  });

  if (label) {
    if (external && url)
      return (
        <a
          aria-label={ariaLabel}
          href={url}
          target="_blank"
          className={`${getVariant()} ${classname} ${tagName}`}
          rel="noreferrer"
        >
          {label}
        </a>
      );

    return url ? (
      <Link
        aria-label={ariaLabel}
        to={url}
        target={target}
        className={`${getVariant()} ${classname} ${tagName}`}
      >
        {label}
      </Link>
    ) : (
      <button
        aria-label={ariaLabel}
        type="button"
        onClick={clickHandler}
        disabled={isDisabled}
        className={`${getVariant()} ${classname} ${tagName}`}
      >
        {label}
      </button>
    );
  }
  return null;
}
